/* eslint-disable arrow-body-style, arrow-parens */

import { Tail } from 'redux-saga/effects';
import { IState } from 'services/root-reducer';
import { store } from 'store';

const isState = (data: any): data is IState => {
    return (
        Object.prototype.hasOwnProperty.call(data, 'operations')
        && Object.prototype.hasOwnProperty.call(data, 'app')
        && Object.prototype.hasOwnProperty.call(data, 'omjs')
        && Object.prototype.hasOwnProperty.call(data, 'favorites')
    );
};

export const WithOptionalState = <T extends (state: IState, ...args: any[]) => any>(func: T) => {
    return (state_opt: false | IState, ...args: Tail<Parameters<T>>): ReturnType<T> => {
        let state = isState(state_opt) ? state_opt : store.getState();
        return func(state, ...args);
    };
};
